<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      v-on="$listeners"
      v-bind="$attrs"
      v-resize="onResize"
      class="mb-2 mx-2"
      :select="jobSelected && jobSelected._id === job._id"
      :hover="hover"
      :scale="1.02"
      :ripple="false"
      style="cursor: auto"
    >
      <div
        class="px-8 py-4 d-flex justify-space-between flex-wrap"
        style="position: relative"
      >
        <!-- <div
          v-if="job.permitir_discapacitados"
          style="position: absolute; right: 25px; top: 25px"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn depressed color="white" small fab v-on="on">
                <v-icon
                  color="grey darken-1"
                >
                  mdi-human-wheelchair
                </v-icon>
              </v-btn>
            </template>
            <span>Apto para personas con discapacidad</span>
          </v-tooltip>
        </div> -->
        <div class="d-flex flex-wrap">
          <v-list-item-avatar
            size="64"
            :color="!job.aviso.empresa.profile_image ? 'primary' : ''"
            class="align-self-start mr-6 d-flex justify-center"
          >
            <v-img
              v-if="!!job.aviso.empresa.profile_image"
              :src="`${host}${job.aviso.empresa.profile_image}`" :alt="job.aviso.empresa.nombre_empresa"
            ></v-img>
            <span v-else class="white--text headline font-weight-bold">
              {{ initials }}
            </span>
          </v-list-item-avatar>
          <div>
            <div class="d-flex justify-space-between align-center mb-3">
              <div>
                <router-link :to="{ name:'administrator companies notices by id', params: { empresa: job.aviso.empresa._id, id: job.aviso._id } }" style="text-decoration: none">
                  <v-list-item-title class="title font-weight-bold" style="white-space: break-spaces !important;" v-text="job.aviso.titulo"></v-list-item-title>
                </router-link>
                <v-list-item-subtitle>
                  <router-link :to="{ name:'administrator companies notices', params: { id: job.aviso.empresa._id } }" style="text-decoration: none">
                    <span class="primary--text font-weight-bold" style="white-space: break-spaces !important;" v-text="job.aviso.empresa.nombre_empresa"></span>
                  </router-link>
                  <span class="font-weight-bold grey--text text--darken-1" v-text="` - ${job.aviso.provincia}, ${job.aviso.ciudad}`"></span>
                </v-list-item-subtitle>
              </div>
            </div>
            <v-list-item-subtitle class="d-flex flex-wrap">
              <div class="mr-4">
                <span class="grey--text mr-2">Fecha de publicación</span>
                <span class="font-weight-bold grey--text text--darken-1" v-text="formatDatePublication"></span>
              </div>
              <div>
                <span class="grey--text mr-2">Fecha de postulación</span>
                <span class="font-weight-bold grey--text text--darken-1" v-text="formatDatePostulation"></span>
              </div>
            </v-list-item-subtitle>
          </div>
        </div>
        <div :class="`d-flex ${ !$vuetify.breakpoint.smAndDown ? 'flex-column align-center' : 'flex-row mt-2 flex-wrap'} `">
          <v-chip
            color="success lighten-5"
            small
            class="mr-2 mb-1 success--text font-weight-bold"
            v-if="job.aviso.estado === 'Publicado'"
          >
            {{ job.aviso.estado }}
          </v-chip>
          <v-chip
            color="grey lighten-3"
            small
            class="mr-2 mb-1 grey--text font-weight-bold"
            v-else
          >
            Aviso finalizado
          </v-chip>
          <v-chip
            color="info lighten-5"
            class="info--text mr-2 mb-1"
            small
            v-if="job.preguntas.length"
            @click.stop.prevent="showPreguntas = !showPreguntas"
          >
            <v-icon x-small class="mr-2">mdi-forum</v-icon>
            Preguntas
          </v-chip>
          <v-chip
            v-if="job.carta_postulacion"
            color="info lighten-5"
            class="info--text"
            small
            @click.stop.prevent="showCartaPostulacion = !showCartaPostulacion"
          >
            <v-icon x-small class="mr-2">mdi-comment-text</v-icon>
            Carta de postulación
          </v-chip>
          
        </div>
      </div>
      <v-container v-if="showCartaPostulacion" class="px-8 py-2">
        <v-row>
          <v-col class="font-weight-bold title pt-0">
            Carta de postulacion
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            {{ job.carta_postulacion }}
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="showPreguntas" class="px-8 py-2">
        <v-row>
          <v-col class="font-weight-bold title pt-0">
            Preguntas
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <div
              v-for="(pregunta, index) of job.preguntas"
              :key="index"
            >
              <div class="font-weight-bold mb-1">{{ pregunta.pregunta }}</div>
              <p class="mb-5">
                {{ pregunta.respuesta }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </BaseMyCard>
  </v-hover>
</template>

<script>
import { windowSizeMixin } from '@/mixin/windowSizeMixin.js';
import config from '@/config';

export default {
  mixins: [windowSizeMixin],
  props: {
    job: {
      type: Object,
      required: true,
    },
    jobSelected: {
      type: Object,
    },
    type: {
      type: String,
      default: 'list2'
    },
    small: {
      default: false,
    },
  },
  data() {
    return {
      showCartaPostulacion: false,
      showPreguntas: false,
      host: config.host,
    }
  },
  computed: {
    formatDatePublication() {
      return this.$moment(this.job.aviso.createdAt).format('DD/MM/YYYY');
    },
    formatDatePostulation() {
      return this.$moment(this.job.createdAt).format('DD/MM/YYYY');
    },
    initials() {
      const nombreEmpresa = this.job.aviso.empresa.nombre_empresa;
      const nombreSplit = nombreEmpresa.split(' ');
			if (nombreSplit.length === 1) return nombreEmpresa[0].toUpperCase();
			else return `${nombreEmpresa[0].toUpperCase()}${nombreEmpresa[1].toUpperCase()}`;
    },
  },
}
</script>

<style>

</style>